module.exports = __webpack_public_path__ + "img/16081862005072.6bfd8725.jpg";